export const tableHeaders = {
  customers: [
    {
      title: "Statut",
      value: "customerStatus",
      width: 110,
      align: "start",
    },
    {
      title: "",
      sortable: false,
      value: "avatar",
      width: 0,
      align: "start",
    },
    {
      title: "n°",
      value: "nClient",
      width: 65,
      align: "start",
    },
    {
      title: "Nom",
      value: "lastName",
      width: 75,
      align: "start",
    },
    {
      title: "Prénom",
      value: "firstName",
      align: "start",
    },
    {
      title: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  companies: [
    {
      title: "Statut",
      value: "customerStatus",
      width: 110,
      align: "start",
    },
    {
      title: "",
      sortable: false,
      value: "avatar",
      width: 0,
      align: "start",
    },
    {
      title: "n°",
      value: "nCompany",
      width: 65,
      align: "start",
    },
    {
      title: "Entreprise",
      value: "name",
    },
    {
      title: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  products: [
    {
      title: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      title: "",
      value: "pictures",
      sortable: false,
      width: 50,
    },

    {
      title: "Référence",
      value: "reference",
      width: 100,
    },
    {
      title: "Prix",
      value: "value",
      width: 100,
    },
    {
      title: "Nom",
      value: "name",
    },
    {
      align: "end",
      title: "",
      value: "manage",
      width: 140,
      sortable: false,
    },
  ],

  warehouseProducts: [
    {
      title: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      title: "",
      value: "pictures",
      sortable: false,
      width: 50,
    },
    {
      title: "Référence",
      value: "reference",
      width: 100,
    },
    {
      title: "Prix",
      value: "value",
      width: 100,
    },
    {
      title: "Nom",
      value: "name",
    },
    {
      title: "Stock",
      value: "stock",
      width: 100,
      align: "center",
      editable: true,
    },
    {
      title: "Minimum",
      value: "minimum",
      width: 120,
      align: "center",
      editable: true,
    },
    {
      align: "end",
      title: "",
      value: "manage",
      width: 140,
      sortable: false,
    },
  ],

  projects: [
    {
      title: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      sortable: false,
      value: "avatar",
      width: 0,
    },
    {
      title: "Intitulé",
      sortable: false,
      value: "title",
      width: 300,
    },
    {
      title: "Client",
      value: "customers",
    },
    {
      title: "Type",
      value: "type",
      width: 100,
    },
    {
      title: "Valeur",
      value: "value",
      width: 100,
    },
    {
      title: "Date de rendu",
      value: "due",
      width: 150,
    },
    {
      title: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  quotes: [
    {
      title: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      align: "start",
      sortable: false,
    },
    {
      title: "N°",
      value: "nQuote",
      width: 100,
    },
    {
      title: "Référence",
      value: "reference",
      width: 150,
    },
    {
      title: "Client",
      value: "customer",
    },
    {
      title: "Prix",
      value: "value",
      width: 200,
    },

    {
      title: "",
      align: "end",
      value: "manage",
    },
  ],

  invoices: [
    {
      title: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      align: "start",
      sortable: false,
    },
    {
      title: "N°",
      value: "nInvoice",
      width: 100,
    },
    {
      title: "Référence",
      value: "reference",
      width: 150,
    },
    {
      title: "Client",
      value: "customer",
    },
    {
      title: "Prix",
      value: "value",
      width: 200,
    },

    {
      title: "",
      align: "end",
      value: "manage",
    },
  ],

  quoteElements: [
    {
      title: "Quantité",
      align: "center",
      sortable: false,
      width: 100,
      value: "quantity",
    },
    {
      title: "Produit",
      align: "start",
      value: "product",
    },
    {
      title: "Prix unité",
      align: "center",
      width: 140,
      value: "value",
    },
    {
      title: "TVA %",
      align: "center",
      width: 90,
      value: "taxRate",
    },
    {
      title: "Total",
      align: "center",
      width: 140,
      value: "total",
    },
  ],

  tasks: [
    {
      title: "",
      value: "status",
      align: "start",
      width: 0,
    },
    {
      title: "Catégorie",
      value: "category",
      width: 10,
    },
    {
      title: "Tâche",
      value: "task",
      groupable: false,
      align: "left",
      width: 300,
    },
    {
      title: "Priorité",
      value: "priority",
      width: 150,
    },
    {
      title: "Deadline",
      value: "dueDate",
      groupable: false,
      width: 100,
    },
    {
      title: "Particip.",
      value: "participants",
      groupable: false,
      width: 160,
    },
    {
      title: "Projet",
      value: "projectData.title",
      groupable: false,
      width: 82,
    },
    {
      title: "",
      value: "manage",
      groupable: false,
      align: "right",
      width: 200,
    },
  ],

  remarks: [
    {
      title: "Date",
      value: "creationDate",
      width: 170,
    },
    {
      title: "Auteur",
      value: "author",
      width: 170,
    },
    {
      title: "Sujet",
      value: "subject",
    },
    {
      title: "Type",
      value: "type",
    },
  ],

  blogs: [
    {
      title: "Nom",
      value: "name",
    },
    {
      title: "Date de création",
      value: "creationDate",
    },
    {
      title: "Actions",
      align: "center",
      value: "actions",
      sortable: false,
    },
  ],

  ia: [
    {
      title: "Commande",
      value: "command",
    },
    {
      title: "Auteur",
      value: "author",
    },
    {
      title: "Tokens",
      value: "tokens",
    },
    {
      title: "Date de création",
      value: "creationDate",
    },
  ],

  warehouses: [
    {
      title: "Nom",
      value: "name",
    },
    {
      align: "end",
      title: "",
      value: "manage",
      width: 180,
      sortable: false,
    },
  ],

  files: [
    {
      title: "Nom",
      value: "name",
    },
    {
      title: "Auteur",
      value: "author",
    },
    {
      title: "Date d'envoi",
      value: "creationDate",
    },
    {
      title: "",
      sortable: false,
      value: "manageDocument",
      width: "200",
    },
  ],
};
